import React, { Component } from 'react';
import * as firebase from "firebase";
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ChatIcon from 'material-ui/svg-icons/communication/chat';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

class Mentor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      memeber_count: 0,
      room_notice: "Creating a Mentor Room",
      open_chat_head: false,
      chat_array: []
    };
    this.sendMessage = this.sendMessage.bind(this);
    this.readMessage = this.readMessage.bind(this);
    this.showMyFace = this.showMyFace.bind(this);
    this.showFriendsFace = this.showFriendsFace.bind(this);
  }

  componentDidMount() {
    this.roomDatabaseref = firebase.database().ref("hand_rooms/" + this.props.match.params.room_id);
    this.roomDatabaseref.on("value",(roomSnap) => {
      if(roomSnap.val() != null){
        this.setState({room_notice: "Room Exist."});
        if(roomSnap.val().mentor)
          this.setState({room_notice: "Room Available, Mentor already exist. Please verify room id."});
        else {
          this.roomDatabaseref.child("mentor").set(true).then(() => {
            this.setState({student_available: true,room_notice: "Added to room successfully, Connecting with Student."});
            window.addEventListener("beforeunload", (ev) =>
            {
                ev.preventDefault();
                this.roomDatabaseref.set(null);
                return ev.returnValue = 'Are you sure you want to close?';
            });
          });
        }
      }else {
        this.setState({student_available: false,room_notice: "Room does not exist or student left, Please verify room ID."})
      }
    });
  }

  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState) {
    if(prevState.student_available !== this.state.student_available && this.state.student_available) {
      this.roomDatabaseref.child("chat/mentor").on("value", (snapshot) => {
        var newChat = snapshot.val();
        if(newChat){
            var chat_list = this.state.chat_array;
            chat_list.push(<p className="chat-rec">{newChat}</p>)
            this.setState({chat_array: chat_list});
        }
        console.log("The updated post title is " + newChat);
      });
      this.signalDBRef = firebase.database().ref("hand_rooms/"+this.props.match.params.room_id+"/signals");
      this.yourVideo = document.getElementById("yourVideo");
      this.studentVideo = document.getElementById("studentVideo");
      this.yourId = Math.floor(Math.random()*1000000000);
      var servers = {
        'iceServers': [
          {'urls': 'stun:35.154.192.229'},
          {'urls': 'turn:35.154.192.229','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229?transport=tcp','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229:443','credential': 'password','username': 'pavi'},
          {'urls': 'turn:35.154.192.229:443?transport=tcp','credential': 'password','username': 'pavi'}]};
      this.pc = new RTCPeerConnection(servers);
      this.showMyFace();
      this.pc.onicecandidate = (event => event.candidate?this.sendMessage(this.yourId, JSON.stringify({'ice': event.candidate})):console.log("Sent All Ice") );
      this.pc.onaddstream = (event => this.studentVideo.srcObject = event.stream);

      this.signalDBRef.on('child_added', this.readMessage);
    }
  }

  sendMessage(senderId, data) {
      var msg = this.signalDBRef.push({ sender: senderId, message: data });
      msg.remove();
  }

  readMessage(data) {
      var msg = JSON.parse(data.val().message);
      var sender = data.val().sender;
      if (sender !== this.yourId) {
          if (msg.ice !== undefined)
              this.pc.addIceCandidate(new RTCIceCandidate(msg.ice));
          else if (msg.sdp.type === "offer")
              this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
                .then(() => this.pc.createAnswer())
                .then(answer => this.pc.setLocalDescription(answer))
                .then(() => this.sendMessage(this.yourId, JSON.stringify({'sdp': this.pc.localDescription})));
          else if (msg.sdp.type === "answer")
              this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
      }
  };

  showMyFace() {
    navigator.mediaDevices.getUserMedia({audio:true, video:true})
      .then(stream => this.yourVideo.srcObject = stream)
      .then(stream => this.pc.addStream(stream));
  }

  showFriendsFace() {
    this.pc.createOffer()
      .then(offer => this.pc.setLocalDescription(offer) )
      .then(() => this.sendMessage(this.yourId, JSON.stringify({'sdp': this.pc.localDescription})) );
  }

  render() {
    return (
      <div>
        {!this.state.student_available &&
          <p
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}
          >
          {this.state.room_notice}
          </p>}
        {this.state.student_available &&
          (<div className="mentor">
              <video id="yourVideo" autoPlay muted></video>
              <video id="studentVideo" autoPlay></video>
              <MuiThemeProvider >
                <FloatingActionButton
                  onClick={(event) => this.showFriendsFace()}
                  style={{
                    position: 'fixed',
                    top: 15,
                    right: 15,
                    zIndex: 2
                  }}>
                  <ChatIcon />
                </FloatingActionButton>
              </MuiThemeProvider >
            </div>)
        }
      </div>
    );
  }
}
export default Mentor;



// WEBPACK FOOTER //
// ./src/Mentor.js